import { getMessages } from '../../../../../../../../store/constants';

export const BOARD_ICON_ARCHIVED = getMessages().getText('common_archived');
